<template>
  <div :class="styleMain" :style="'grid-area:'+this.grid">
    <el-select v-model="value" :placeholder="type" :clearable="true">
      <el-option v-for="item in items" :key="item.id" :label="item.name" :value="item" :popper-class="styleMain.join(' ')" />
    </el-select>
    <label v-if="value">{{ type }}</label>
  </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionTypeTemplate',
  props: {
    action: Object,
    type: String,
    grid: String,
    items: Array
  },
  computed: {
    typeId () { return this.type.toLowerCase() + 'Id' },
    value: {
      get () { return this.items.find((item) => { return item.id === this.action[this.typeId] })?.name },
      set (value) {
        const data = { id: this.action.id }
        if (value) {
          data[this.typeId] = value.id
        } else {
          data[this.typeId] = null
        }
        this.$store.dispatch('Sport/Football/Match/putAction', data)
      }
    },

    styleMain () { return ['sportFootballMatchActionTypeTemplate', this.action.homeAway] }
  }
}
</script>

<style>
.sportFootballMatchActionTypeTemplate {
  position:relative
}
.sportFootballMatchActionTypeTemplate > div{
  width: 100%
}
.sportFootballMatchActionTypeTemplate input{
  font-weight:600;
  height:35px;
  border:none;
  text-align: left;
}
.sportFootballMatchActionTypeTemplate.home input{
  color: var(--color-team-home);
}
.sportFootballMatchActionTypeTemplate.away input{
  color: var(--color-team-away);
}
.sportFootballMatchActionTypeTemplate label{
  position: absolute;
  top: 2px;
  left: 5px;
  font-size: 8px;
  color: var(--color-font-grey-light);
}
.sportFootballMatchActionTypeTemplate.home{
  color: var(--color-team-home);
}
.sportFootballMatchActionTypeTemplate.away{
  color: var(--color-team-away);
}
</style>
